// extracted by css-extract-rspack-plugin
export default {"Panel":"ArtifactsSidePanelOverlay-module__Panel__mkDPE","Content":"ArtifactsSidePanelOverlay-module__Content__sR8Sq"};